const { navMobile } = require("./modules/nav-mobile");
const { slideMenu } = require("./modules/slide-menu");
const { popup } = require("./modules/popup");
const { lightBoxInit } = require("./modules/lightbox");
const { backgroundVideoInit } = require("./modules/background-video");
const { scrollFlag } = require("./modules/nav-scrollFlag");
const { contrastMode } = require("./modules/contrast-mode");
const { fontSizeAccessibility } = require("./modules/font-size-accessibility");
const { navScrollMenu } = require("./modules/nav-scrollMenu");
const { megamenuInit } = require("./modules/nav-megamenu");
const { archiveFilter } = require("./modules/archive-filter");
const { searchOverlay } = require("./modules/search-overlay");
const { lexideskButtons, lexideskWpmlFix } = require("./modules/lexidesk");
const { initNavFooterMobile } = require("./modules/nav-footer-mobile");
const { desktopLevelMenuHelper } = require("./modules/desktop-level-menu-helper");
const { copyPostLink } = require("./modules/copy-post-link");

copyPostLink();

document.addEventListener("DOMContentLoaded", () => {
  contrastMode();
  fontSizeAccessibility();
    AOS.init({
        offset: 60, // offset (in px) from the original trigger point
        duration: 1200,
        once: true
    });
    scrollFlag();
    navMobile();
    slideMenu();
    backgroundVideoInit();
    popup();
    lightBoxInit();
    navScrollMenu();
    archiveFilter();
    searchOverlay();
    lexideskButtons();
    lexideskWpmlFix();
    initNavFooterMobile();
    desktopLevelMenuHelper();

    window.addEventListener("load", () => {
        megamenuInit();
    });

    window.addEventListener("scroll", () => {
        scrollFlag();
    });

    window.addEventListener("resize", () => {
        backgroundVideoInit();
    });
});
